import { render, staticRenderFns } from "./CompanyFieldApprovalResults.vue?vue&type=template&id=2d0ab39c&"
import script from "./CompanyFieldApprovalResults.vue?vue&type=script&lang=js&"
export * from "./CompanyFieldApprovalResults.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFieldApprovalResults.vue?vue&type=style&index=0&id=2d0ab39c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports